export default __webpack_public_path__ + "static/media/Lorena_e_Gulio.56a9fd07.jpg";